import { Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

export const Title: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Typography variant="h1" fontWeight="bold" sx={{ fontSize: { xs: '22px', md: '28px' } }}>
      {children}
    </Typography>
  );
};

export const Body1: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Typography variant="body1" my={3}>
      {children}
    </Typography>
  );
};
